module.exports = __webpack_public_path__ + "static/media/inovice gen.7d1829c9.png";